import React, { createContext, useContext } from 'react';
import { useLoginProfile } from '../hooks/useLoginProfile';

type LoginProfileState = ReturnType<typeof useLoginProfile>;

const LoginProfileContext = createContext<LoginProfileState>({
  profile: null,
  loading: false,
  error: false,
});

export function LoginProfileProvider({
  children,
}: {
  children: React.ReactNode;
}) {
  const state = useLoginProfile();
  return (
    <LoginProfileContext.Provider value={state}>
      {children}
    </LoginProfileContext.Provider>
  );
}

export function useLoginProfileContext(): LoginProfileState {
  return useContext(LoginProfileContext);
}
